import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../api';
import api from '../../api/endpoints';

function* getVerifiedDomains({ payload: { signal, curr_page } }) {
  try {
    const { data } = yield call(fetch, { api: api.verifiedDomains, params: { page: curr_page }, signal });

    const preparedData = {
      domains: data.results,
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    yield put(actions.getVerifiedDomainsDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getVerifiedDomainsFailed,
      endpoint: api.verifiedDomains.url
    });
  }
}

export const getVerifiedDomainsSaga = takeEvery(types.GET_VERIFIED_DOMAINS_REQUEST, getVerifiedDomains);